import { call, put, select, takeLatest } from 'redux-saga/effects';

import teamService from 'services/teamService';

import { getUser } from 'store/session/selectors';

import {
  resendSesVerificationEmail,
  sesVerificationFailureModal,
} from './actions';
import { types } from './actions';

export function* watchResendSesVerificationEmail() {
  yield put(sesVerificationFailureModal.close());
  try {
    const user = yield select(getUser);
    yield call(teamService.sendVerificationEmail, user.id);
    yield put(resendSesVerificationEmail.success());
  } catch (error) {
    yield put(resendSesVerificationEmail.error({ error }));
  }
}

export default function* root() {
  yield takeLatest(
    types.RESEND_SES_VERIFICATION_EMAIL_REQUEST,
    watchResendSesVerificationEmail,
  );
}
